export default __webpack_public_path__ + "static/media/Aqi.58fae3c6.png";